import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { usePostHog } from 'posthog-js/react'

const Nav: React.FC = () => {
  const location = useLocation()
  const prefix = location.pathname === '/' ? '' : '/'
  const posthog = usePostHog()
  return (
    <nav className='flex items-center justify-between px-4 md:px-10 py-[1.15rem] bg-white/90 backdrop-blur-md border-b border-black/[0.06] sticky top-0 z-50'>
      <Link
        className='font-hd font-extrabold text-[20px] tracking-[-0.8px] text-ink no-underline'
        to='/'
      >
        zeiger<span className='text-pop not-italic'>.</span>
      </Link>
      <div className='flex items-center gap-8'>
        <a
          href={prefix + '#services'}
          className='hidden md:block text-ink3 no-underline text-[13.5px] font-medium hover:text-ink transition-colors'
        >
          Services
        </a>
        <a
          href={prefix + '#why'}
          className='hidden md:block text-ink3 no-underline text-[13.5px] font-medium hover:text-ink transition-colors'
        >
          Why us
        </a>
        <a
          href={prefix + '#reviews'}
          className='hidden md:block text-ink3 no-underline text-[13.5px] font-medium hover:text-ink transition-colors'
        >
          Reviews
        </a>
        <a
          href={prefix + '#contact'}
          onClick={() => posthog?.capture('nav_cta_clicked')}
          className='bg-pop text-white px-[22px] py-[10px] rounded-lg font-semibold text-[13.5px] hover:bg-pop-hover transition-colors no-underline'
        >
          Talk to us today
        </a>
      </div>
    </nav>
  )
}

export default Nav
